export enum ProductApprovalStatusCodeEnum {
  APPROVED = 4,
  PENDING = 1,
  REJECTED = 5,
  DRAFT = 7,
}

export enum ProductApprovalStatusEnum {
  APPROVED = 'approved',
  PENDING = 'pending',
  REJECTED = 'reject',
  DRAFT = 'draft',
  SOLD = 'sold',
}

export enum ProductActiveStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum ProductStockStatusEnum {
  ANY,
  IN_STOCK = '>0',
  OUT_OF_STOCK = '=0',
}
